/**
 * 329 (FR-010, research R3) — whether the schedule Guide opens by itself. It opens on a browser's
 * first visit, and after that only when asked: closing it is remembered here, per browser, like the
 * density (318), and never on the server.
 *
 * 🔴 Every storage access is guarded: in a private window or with site data blocked the accessor
 * itself can throw. The Guide then opens on each visit, and the schedule still works.
 */

export const GUIDE_STORAGE_KEY = 'carii-admin-schedule-guide';

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

/** Whether the Guide starts open. A first visit also records that the Guide has now been shown. */
export function initialGuideOpen(storage: StorageLike | undefined): boolean {
  try {
    const stored = storage?.getItem(GUIDE_STORAGE_KEY);
    if (stored === 'seen-closed') return false;
    if (stored !== 'open') storage?.setItem(GUIDE_STORAGE_KEY, 'open');
    return true;
  } catch {
    return true;
  }
}

export function writeGuideOpen(storage: StorageLike | undefined, open: boolean): void {
  try {
    storage?.setItem(GUIDE_STORAGE_KEY, open ? 'open' : 'seen-closed');
  } catch {
    // The choice applies for this visit; it simply is not remembered.
  }
}
